function isTouchDevice() {
  return 'ontouchstart' in window // works on most browsers 
      || window.navigator.msMaxTouchPoints > 0; // works on ie10
}

jQuery(document).ready(function($) {
  console.log('Is touch device is working.');
  if(isTouchDevice()) $('body').addClass('touch');
});